module.exports = __webpack_public_path__ + "static/media/dice-2.da0d0cba.svg";